export var McDLaborRoutes = {
    "/mcd-labor": {
        "loginRequired": true,
        "name": "appLayout.schedule.mcd-labor",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "mcdLaborWeeksListContainer"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./../activity-based-scheduling-generation/activity-based-scheduling-generation.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./mcd-labor.module.js");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["mcd-labor", "abs-generation"]
        },
        "onEnter": ['userServices', '$state', 'TeamScheduleService', 'hUser',
            function (userServices, $state, TeamScheduleService, hUser) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        userServices.isServiceEnabled(userServices.SERVICES.MCD_LABOR_MODEL, brand.id)
                            .then(function (isMcDLaborServiceEnabled) {
                                if (!isMcDLaborServiceEnabled || !hUser.hasSalesAccess()) {
                                    $state.go("appLayout.schedule.main");
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    });
            }]
    },
    "/mcd-labor-projections?date": {
        "loginRequired": true,
        "name": "appLayout.schedule.mcd-labor-projections",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "laborProjectionsContainer"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./../activity-based-scheduling-generation/activity-based-scheduling-generation.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./../../activity-based-scheduling/activity-based-scheduling.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./mcd-labor.module.js");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["mcd-labor", "abs-generation"]
        },
        "onEnter": ['userServices', '$state', 'TeamScheduleService', 'hUser',
            function (userServices, $state, TeamScheduleService, hUser) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        userServices.isServiceEnabled(userServices.SERVICES.MCD_LABOR_MODEL, brand.id)
                            .then(function (isMcDLaborServiceEnabled) {
                                if (!isMcDLaborServiceEnabled || !hUser.hasSalesAccess()) {
                                    $state.go("appLayout.schedule.main");
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    });
            }]
    }
};
